module.exports = __webpack_public_path__ + "static/media/member7.bc0a80a6.png";